export const searchBarController = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: 'getSearchBarConfig',
      },
    },
    getSearchBarConfig: {
      invoke: {
        src: 'getSearchBar',
        onDone: {
          target: 'idle',
          actions: {
            type: 'batchLayoutOperations',
            data: '$event.data.updates',
            meta: {
              selectors: ['$action.data'],
            },
          },
        },
      },
    },
  },
};
